import {types} from './types';

const setGetReplenishmentReportAction = (payload) => {
    return {
        type: types.SET_REPLENISHMENT_REPORT,
        payload,
      }
}

const setGetReplenishmentAction = (payload) => {
  return {
      type: types.SET_REPLENISHMENT,
      payload,
    }
}

const setGetShiftAction = (payload) => {
  return {
      type: types.SET_SHIFT,
      payload,
    }
}

export {
  setGetReplenishmentReportAction,
  setGetReplenishmentAction,
  setGetShiftAction
}
